import { ref, computed } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

const validateDuplicateDni = (dniValue, entradaId, todasEntradas) => {
    if (!dniValue || !todasEntradas?.length) return null;
    const dniNorm = dniValue.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
    const duplicate = todasEntradas.some(e => {
        if (e.id === entradaId) return false;
        if (!e.user_dni) return false;
        const otherNorm = String(e.user_dni).toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
        return otherNorm === dniNorm;
    });
    return duplicate ? 'perfil.edit_ticket.duplicate_dni' : null;
};

export function useEditTicket() {
    const nombre    = ref('');
    const apellidos = ref('');
    const tipoDoc   = ref('');
    const dni       = ref('');
    const loading   = ref(false);
    const error     = ref(null);

    // isValid solo comprueba campos no vacíos. La validación de formato DNI
    // la hace vee-validate a través de DocumentValue (regla 'identificacion').
    const isValid = computed(() => !!nombre.value.trim() && !!apellidos.value.trim() && !!tipoDoc.value && !!dni.value.trim());

    const init = entrada => {
        nombre.value    = entrada.user_nombre    || '';
        apellidos.value = entrada.user_apellidos || '';
        tipoDoc.value   = entrada.user_tipo_doc  || 'DNI';
        dni.value       = entrada.user_dni       || '';
        error.value     = null;
    };

    const reset = () => {
        nombre.value    = '';
        apellidos.value = '';
        tipoDoc.value   = '';
        dni.value       = '';
        error.value     = null;
        loading.value   = false;
    };

    const update = async(entrada, userOrderId) => {
        loading.value = true;
        error.value    = null;
        try {
            const data = {
                user_nombre:    nombre.value,
                user_apellidos: apellidos.value,
                user_dni:       dni.value,
                user_order_id:  userOrderId || entrada.tpv_order,
                user_ticket_id: entrada.id,
            };
            await store.dispatch(config.getVuexAlias('front.perfil.ticket.update'), data);
            return true;
        } catch (err) {
            const msgs = err?.response?.data?.errors;
            error.value = msgs
                ? Object.values(msgs).flat().join(' ')
                : (err?.message || 'Error al guardar los datos');
            return false;
        } finally {
            loading.value = false;
        }
    };

    return { nombre, apellidos, tipoDoc, dni, isValid, loading, error, init, reset, update, validateDuplicateDni };
}
